<template>
  <div class="multipleTree">
    <div v-if="treeData.length === 0">该模块没有东西可瞅</div>
    <a-tree
      v-else
      ref="antree"
      :selectable="false"
      :tree-data="mydata"
      :expand-on-click-node="false"
      show-line
      checkable
      @check="onSelect"
    />
  </div>
</template>
<script>
  export default {
    props: {
      treeData: {
        type: Array,
        default() {
          return [
            // {
            //   title: 1,
            //   key: 1,
            //   children: [
            //     { title: '1 - 1', key: '1 - 1', children: [] },
            //     { title: '1 - 2', key: '1 - 2', children: [] }
            //   ]
            // },
          ]
        }
      },

      asyn: {
        type: Boolean,
        default: false
      },
      defaultKey: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data() {
      return { mydata: [], selectedKeys: [], temp: {} }
    },
    watch: {
      treeData: {
        handler() {
          this.temp = {}
          this.mydata = this.treeData.map(i => this.mapTree(i))
        },
        immediate: true
      },
      defaultKey: {
        handler(val) {
          this.selectedKeys = val
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      onSelect(selectedKeys, info) {
        // 只获得末端的id
        selectedKeys = selectedKeys.filter(i => !this.temp[i])
        this.$emit('check', selectedKeys, info.node.$options.propsData.dataRef)
      },
      mapTree(org, parent = { key: 0, pathIds: [0] }) {
        const haveChildren =
          Array.isArray(org.children) && org.children.length > 0
        // 记录有子集的数据
        if (haveChildren) this.temp[org.key] = true
        let item = {
          key: org.key,
          ...org,
          pathIds: [...parent.pathIds, org.key]
        }
        return {
          // 分别将我们查询出来的值做出改变他的key
          title: org.title,
          key: org.key,
          ...org,
          parent: parent,
          pathIds: [...parent.pathIds, org.key], // 深度 循环 依次key  用于查询
          // 判断它是否存在子集，若果存在就进行再次进行遍历操作，知道不存在子集便对其他的元素进行操作
          children: haveChildren
            ? org.children.map(i => this.mapTree(i, item))
            : []
        }
      },
      onLoadData(treeNode) {
        return new Promise(resolve => {
          if (treeNode.dataRef.children.length) {
            resolve()
            return
          }
          this.$emit('onLoadData', treeNode, resolve)
        })
      }
    }
  }
</script>

<style lang="less">
  .multipleTree {
    .ant-tree-switcher,
    .ant-tree-title,
    .ant-tree-node-content-wrapper {
      height: 32px !important;
      line-height: 32px !important;
      display: inline-block;
      // width: 85%;
    }

    .ant-tree.ant-tree-show-line li:not(:last-child):before {
      position: absolute;
      left: 12px;
      width: 1px;
      height: 100%;
      height: calc(100% - 22px);
      margin: 22px 0 0;
      border-left: @border-width-base #d9d9d9 dashed;
      content: ' ';
    }

    .ant-tree li span.ant-tree-switcher.ant-tree-switcher-noop {
      display: inline-block;
      background-image: url('./open.png') !important ;
      background-size: 14px !important;
      background-position: center !important;
      background-repeat: no-repeat !important;
      i {
        display: none;
      }
    }

    .ant-tree {
      font-size: @font-size-base;
      font-weight: 400;
      line-height: 32px;
      color: @text-color-secondary;
    }

    .ant-tree-treenode-checkbox-checked .ant-tree-node-content-wrapper {
      font-weight: 500 !important;
      color: @primary-color !important;
    }
    .ant-tree li .ant-tree-node-selected {
      font-weight: 500 !important;
      color: @primary-color !important;
      background-color: #dceeff !important;
      &:hover {
        background-color: #dceeff !important;
      }
    }

    .ant-tree-switcher_close {
      background-image: url('./close.png') !important ;
      background-size: 14px !important;
      background-position: center !important;
      background-repeat: no-repeat !important;
      i {
        display: none;
      }
    }
    //打开样式
    .ant-tree-switcher_open {
      background-image: url('./open.png') !important ;
      background-size: 14px !important;
      background-position: center !important;
      background-repeat: no-repeat !important;
      i {
        display: none;
      }
    }
  }
</style>
